import React from "react";
import { NavLink } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../../firebase";
import { useNavigate } from "react-router-dom";
import "../owner/OwnerDashboard.css";

export default function CharityLayout({ children }) {
  const navigate = useNavigate();
  const handleLogout = async () => {
    await signOut(auth);
    navigate("/login");
  };
  return (
    <div className="dashboard-shell" style={{ display: "flex" }}>
      <div style={{ width: "220px", background: "#14101F", padding: "20px" }}>
        <h2 style={{ marginBottom: "30px", color: "#fff" }}>Charity Menu</h2>

        <nav style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <NavLink to="/charity" end className={({ isActive }) => `tab ${isActive ? "active" : ""}`}>
            Overview
          </NavLink>
          <NavLink to="/charity/claim-bar" className={({ isActive }) => `tab ${isActive ? "active" : ""}`}>
            Claim Bar
          </NavLink>
          <NavLink to="/charity/linked-bars" className={({ isActive }) => `tab ${isActive ? "active" : ""}`}>
            Linked Bars
          </NavLink>
          <NavLink to="/charity/events" className={({ isActive }) => `tab ${isActive ? "active" : ""}`}>
            Events
          </NavLink>
          <NavLink to="/charity/gaming" className={({ isActive }) => `tab ${isActive ? "active" : ""}`}>
            Gaming
          </NavLink>
          <NavLink to="/charity/notifications" className={({ isActive }) => `tab ${isActive ? "active" : ""}`}>
            Notifications
          </NavLink>
          <NavLink to="/charity/subscription" className={({ isActive }) => `tab ${isActive ? "active" : ""}`}>
            Boost &amp; Pro
          </NavLink>
          <NavLink to="/charity/help" className={({ isActive }) => `tab ${isActive ? "active" : ""}`}>
            Help
          </NavLink>
          <NavLink to="/charity/account" className={({ isActive }) => `tab ${isActive ? "active" : ""}`}>
            Account
          </NavLink>
          <a href="https://barfunfinder.com/advertise.html" target="_blank" rel="noopener noreferrer" className="tab">
            Advertise
          </a>
          <button
            onClick={handleLogout}
            style={{
              background: "rgba(255,255,255,0.1)",
              border: "1px solid rgba(255,255,255,0.2)",
              padding: "10px 16px",
              borderRadius: "8px",
              color: "#fff",
              cursor: "pointer",
              fontWeight: 600,
              marginTop: "20px",
            }}
          >
            Log Out
          </button>
        </nav>
      </div>

      <div style={{ flex: 1 }}>
        <header className="dashboard-header">
          <h1 style={{ margin: 0 }}><img src="/logo-header.png" alt="Bar Fun Finder" style={{ height: "56px", width: "auto", display: "block" }} /></h1>
          <p>Charity Dashboard</p>
        </header>
        <main className="dashboard-content">{children}</main>
      </div>
    </div>
  );
}
